<template>
  <div>
    <!-- slot for parent component to activate the file changer -->
    <div @click="launchFilePicker()">
      <slot name="activator" />
    </div>

    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input 
      ref="file"
      :name="fieldName"
      :accept="acceptType"
      type="file"      
      style="display:none"      
      @change="onFileChange($event.target.name, $event.target.files)"      
    >

    <!-- error dialog displays any potential error messages -->
    <v-dialog 
      v-model="errorDialog" 
      max-width="300"
    >
      <v-card>
        <v-card-text> {{ errorText }} </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn 
            text
            @click="errorDialog = false"
          > 
            Got it!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      // Use "value" to enable using v-model
      value: {
        type: Object,
        default: null,
      },
      maxSizeInMb: {
        type: Number,
        required: true,
      },
      fieldName: {
        type: String,
        required: true,
      },
      acceptType: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      errorDialog: null,
      errorText: '',
    }),  
    watch: {
      value: {
        handler (newValue) {
          if (!newValue) {
            this.$refs.file.value = ''
          }
        },
        deep: true,
      },
    },
    methods: {
      launchFilePicker () {
        this.$refs.file.click()
      },
      onFileChange (fieldName, files) {
        if (files.length <= 0) return

        const imageFile = files[0]
        const sizeInMb = this.bytesToMB(imageFile.size)

        if (sizeInMb > this.maxSizeInMb) {
          // check whether the size is greater than the size limit
          this.errorDialog = true
          this.errorText = `Your file is too big! Please select an image under ${this.maxSizeInMb}MB`
        } else {
          // Append file into FormData and turn file into image URL
          const formData = new FormData()
          const imageURL = URL.createObjectURL(imageFile)

          formData.append(fieldName, imageFile)

          // Emit the FormData and image URL to the parent component
          this.$emit('input', { formData, imageURL, imageFile })
        }
      },
      bytesToMB (bytes) {
        if (bytes === 0) return 'n/a'

        return (bytes / (1024 ** 2)).toFixed(1)
      },    
    },
  }
</script> 
